import type { PlanungUnavailability } from "@/lib/montageplanung";
import { formatDateDe } from "./dateUtils";

export function isDateInIsoRange(dayIso: string, fromIso: string, toIsoStr: string): boolean {
  const day = dayIso.slice(0, 10);
  const from = fromIso.slice(0, 10);
  const to = toIsoStr.slice(0, 10);
  return day >= from && day <= to;
}

export function findUnavailabilityOnDay(
  rowId: number,
  dayIso: string,
  blocks: PlanungUnavailability[],
): PlanungUnavailability | undefined {
  return blocks.find(
    (b) => b.row_id === rowId && isDateInIsoRange(dayIso, b.date_from, b.date_to),
  );
}

export function isUnavailableDay(
  rowId: number,
  dayIso: string,
  blocks: PlanungUnavailability[],
): boolean {
  return findUnavailabilityOnDay(rowId, dayIso, blocks) != null;
}

/** Rechtsklick: Start und Ende sind der angeklickte Tag. */
export function defaultUnavailableDay(dayIso: string): { date_from: string; date_to: string } {
  const day = dayIso.slice(0, 10);
  return { date_from: day, date_to: day };
}

export interface UnavailabilityLabelSpan {
  id: number;
  start: number;
  end: number;
  text: string;
}

/** Grund als durchgehende Beschriftung über die schraffierten Tage. */
export function unavailabilityLabelSpans(
  rowId: number,
  blocks: PlanungUnavailability[],
  dayIsos: string[],
): UnavailabilityLabelSpan[] {
  const spans: UnavailabilityLabelSpan[] = [];
  for (const block of blocks) {
    if (block.row_id !== rowId) continue;
    const text = block.note?.trim();
    if (!text) continue;
    let start = -1;
    let end = -1;
    dayIsos.forEach((iso, index) => {
      if (!isDateInIsoRange(iso, block.date_from, block.date_to)) return;
      if (start < 0) start = index;
      end = index;
    });
    if (start < 0 || end < start) continue;
    spans.push({ id: block.id, start, end, text });
  }
  return spans;
}

export function unavailabilityDayTitle(block: PlanungUnavailability): string {
  const range = `${formatDateDe(block.date_from)} – ${formatDateDe(block.date_to)}`;
  const note = block.note?.trim();
  return note ? `Nicht verfügbar: ${range} — ${note}` : `Nicht verfügbar: ${range}`;
}
